<template>
  <!--<h3>获取密码</h3>-->
  <div>
    <search-list :projectList="BuildInfo" :roomStatusList="roomStatusList" @findData="findData" :setDefault="setDefault"></search-list>
    <div class="page-wrapper">
    <div class="mt12">
  
      <Button type="primary" @click.stop="showGetPwdModal" v-p="{api:'smartlock/sendSmartLockPwd'}">获取密码</Button>
      <get-password-modal :n="n2" :userTypeList="userTypeList" :pwdEffectiveTimeList="pwdEffectiveTimeList" @getpassword="getPwd" @changeusertype="changeUserType" @clearTable="clearTable" :lockNum="selection.length"></get-password-modal>
      <table-list title="" :columns="columns" :data="data" :loading="loading" :total="total" :current="current" @change-page="changePage" @on-selection-change="selectItem" @on-select="onSelect" ref="table-list"></table-list>
    </div>
    </div>
    <div>
      <lockinfo-modal :detailModal="detailModal" :n="n" :info="lockInfo" @closeLockInfo="closeLockInfo"></lockinfo-modal>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SearchList from "./components/SearchList";
import TableList from "components/FilterTableList/index";
import GetPasswordModal from "./components/GetPasswordModal";
import LockinfoModal from "./components/LockinfoModal";
import {
  getLockList,
  getUserType,
  pwdEffectiveTime,
  sendSmartLockPwd,
  getDetail
} from "api/getPassword";
import { getEmployeeByCode, getRoomstatus } from "api/common";
import { getBuildInfo } from "api/functionalArea";
import { deepClone } from "../../../utils/format";

export default {
  name: "getpsd",
  components: {
    SearchList,
    TableList,
    GetPasswordModal,
    LockinfoModal
  },
  data() {
    return {
      defaultList: [],
      n: 0,
      n2: 0,
      searchData: null,
      pwdModal: false,
      detailModal: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          key: "index",
          width: 60,
          align: "center"
        },
        {
          title: "项目名称",
          width: 130,
          key: "projectName",
          align: "center"
        },
        {
          title: "房间号",
          key: "roomNumber",
          align: "center"
        },
        {
          title: "楼栋",
          key: "buildingName",
          align: "center"
        },
        {
          title: "楼层",
          key: "floorNumber",
          align: "center"
        },
        {
          title: "房间状态",
          key: "roomStatus",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              {},
              this.roomStatusMap[params.row.roomStatus + ""]
            );
          }
        },
        {
          title: "签约人",
          key: "customerName",
          align: "center"
        },
        {
          title: "实际入住人",
          key: "userName",
          align: "center"
        },
        {
          title: "合同号",
          key: "conRentCode",
          align: "center"
        },
        {
          title: "起租日",
          key: "conStartDate",
          align: "center",
          render: (h, param) => {
            return h("span", {}, this.formateDate(param.row.conStartDate));
          }
        },
        {
          title: "到期日",
          key: "conEndDate",
          align: "center",
          render: (h, param) => {
            return h("span", {}, this.formateDate(param.row.conEndDate));
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          render: (h, params) => {
            return h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'smartlock/getDetail'
                    }
                  }
                ],
                style: {
                  marginRight: "5px"
                },
                on: {
                  click: () => {
                    this.showDetail(params);
                  }
                }
              },
              "详情"
            );
          }
        }
      ],
      data: [],
      current: 1,
      total: 0,
      loading: false,
      BuildInfo: [],
      userTypeList: [],
      roomStatusList: [],
      pwdEffectiveTimeList: [],
      selection: [],
      getPwdParams: {},
      lockInfo: {
        onoffLine: "",
        power: "",
        roomId: ""
      },
      setDefault: false
    };
  },
  computed: {
    listValid() {
      return this.selection.length > 0 ? true : false;
    },
    roomStatusMap() {
      let map = {};
      this.roomStatusList.forEach(ele => {
        map[ele.value + ""] = ele.text;
      });
      return map;
    }
  },

  created() {
    getBuildInfo().then(res => {
      if(!res.data){
        return
      }
      this.BuildInfo = res.data;
      this.BuildInfo.length > 0 && (this.setDefault = true);
    });
    getUserType().then(res => {
     res.data && ( this.userTypeList = res.data );
    });
    getRoomstatus().then(res => {
      res.data && (this.roomStatusList = res.data);
    });
    let defalut = { userType: "1" };
    pwdEffectiveTime(defalut).then(res => {
      if(!res.data){
        return
      }

      this.pwdEffectiveTimeList = res.data;
      this.defaultList = res.data;
    });
  },
  methods: {
    closeLockInfo() {
      this.lockInfo = {
        onoffLine: "",
        power: "",
        roomId: ""
      };
    },
    clearTable() {
      this.$refs["table-list"].$refs["table"].selectAll(false);
    },
    formateDate(timestamp) {
      if (!timestamp) {
        return "-";
      }
      var date = new Date(Number(timestamp));
      return (
        date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      );
    },
    onSelect(selection, row) {},
    changeUserType(data) {
      let params = {
        userType: data
      };
      pwdEffectiveTime(params).then(res => {
        this.pwdEffectiveTimeList = res.data;
      });
    },
    getPwd(params) {
      var data = {};
      Object.assign(data, params);
      data["projectId"] = this.selection[0].projectId;
      var roomids = [];
      this.selection.forEach(ele => {
        roomids.push(ele.roomId);
      });
      data["roomIds"] = roomids.join("_");
      data["isSendMsg"] = 1;

      sendSmartLockPwd(data)
        .then(res => {
          this.$Message.success("操作成功，密码正在下发中，请稍等");
        })
        .catch(error => {
          this.$Message.error("密码获取失败，请稍后再试");
        });
    },
    showGetPwdModal() {
      if (this.selection.length == 0) {
        this.$Message.warning("请选择智能锁");
        return;
      }
      this.pwdEffectiveTimeList = this.defaultList;
      this.n2++;
    },
    selectItem(selection) {
      this.selection = deepClone(selection);
    },
    findData(params) {
      this.current=1;
      this.searchData = Object.assign({}, params);
      this.initLockList(this.searchData);
    },
    changePage(n) {
      this.current = n;
      if (this.searchData !== null) {
        this.searchData.page = n;
        this.initLockList(this.searchData);
      }
    },
    initLockList(params) {
      getLockList(params).then(res => {
        this.data = res.data.rows;
        this.total = res.data.total;
      });
    },
    showDetail(param) {
      let data = {
        roomId: param.row.roomId
      };

      getDetail(data).then(res => {
        this.lockInfo.onoffLine = res.data.onoffLine;
        this.lockInfo.power = res.data.power;
        this.lockInfo.roomId = param.row.roomId;
        this.n++;
      });
    }
  }
};
</script>

<style lang="css" scoped>
.pwl-title {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  color: #495060;
  margin-bottom: 18px;
}
.pwl-button {
  /*background-color: rgb(80, 153, 247);*/
  color: #fff;
  background-color: #cfa868;
  border-color: #cfa868;
  padding: 10px 36px;
  border-radius: 4px;
}

.bg2 {
  background-color: rgb(220, 220, 220);
}
</style>
